

import Vue from 'vue'
import App from './App'
import router from './router'
import * as baseFilter from './filters/baseFilter'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'


import Toast from '@components/common/toast'


const CONSTS = require('./consts/const')
import store from '@/store'


Object.keys(baseFilter).forEach(key => Vue.filter(key, baseFilter[key]))

Vue.config.productionTip = false











Vue.use(Toast)
Vue.use(LoadingPlugin)
Vue.use(router)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(WechatPlugin)
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>',
store
})



// WEBPACK FOOTER //
// ./src/main.js